import { useEffect } from 'react';
import { usePostHogUserIdentification } from './postHogIntegration';
import { userActions } from './userStore';

/**
 * Component to initialize the user store and handle PostHog integration.
 * Should be mounted once at the app level.
 */
export const UserStoreInitializer = () => {
    // Handle PostHog integration
    usePostHogUserIdentification();

    // Initialize user data on mount - refreshUser handles token validation
    useEffect(() => {
        userActions.fetchMe();
    }, []);

    return null;
};
